
import { useEffect, useState } from 'react'
import Style from './style2.module.css'
import LeftSidePopupLayout from '../../../../component/popup/modal-layout'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import UpdateBillPopup from './update'

const UpdateBill = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, billId }) => {

    const [allRecords, setAllRecords] = useState([])

    const apiCall = useApiCall();

    const getAllRecords = async() => {
        try {
            let apiRes = await apiCall({method: "get", url: "get-water-tanker-entry-list?status=pending"});
            // console.log("apiRes", apiRes)
            setAllRecords(apiRes?.data)
        } catch (error) {
            console.log("Error", error)
        }
    }

    useEffect(() => {
        getAllRecords()
    } , [])

    return (
        <>
            <div className={Style.modal_body}>
                <LeftSidePopupLayout popupStatus={true} className={`${Style.departmentChangeModal}`}>

                    <UpdateBillPopup
                        onClose={onClose}
                        onError={onError}
                        onSubmit={onSubmit}
                        Style={Style}
                        records={allRecords}
                        billId={billId}
                    />
                </LeftSidePopupLayout>
            </div>
        </>
    )
}

export default UpdateBill
